import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DataStore } from 'aws-amplify';
import { LocationType, User, UserRole, Warehouse } from 'models';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProfileService {
    profile: User;
    isNational = false;
    selectedWarehouseId = '';

    constructor(private router: Router) {}

    async getProfile() {
        const id = localStorage.getItem('user');
        const p = await DataStore.query(User, (u) => u.cognitoId('eq', id));
        this.profile = p[0];
        this.setWarehouseId();
        return this.profile;
    }
    setWarehouseId() {
        // Fix in place for users that might have experienced a bug where warehouseID was set as undefined
        if (localStorage.getItem('warehouseId') === 'undefined') {
            localStorage.removeItem('warehouseId');
        }

   
        if (localStorage.getItem('warehouseId')) {
            this.selectedWarehouseId = localStorage.getItem('warehouseId');
        } else {
            if (this.profile?.warehouse?.id) {
                localStorage.setItem(
                    'warehouseId',
                    this.profile?.warehouse?.id
                );
                this.selectedWarehouseId = this.profile?.warehouse?.id;
            }
        }

        if (this.profile?.warehouse?.locationType === 'NATIONAL') {
            this.isNational = true;
        }
    }

    getwarehouseId() {
        return this.selectedWarehouseId;
    }

    /**
     * Check if user can see all data or only selected warehouse
     * @returns boolean
     */
    isAdmin(): boolean {
        if (
            this.profile.role === UserRole.MOBILE ||
            this.profile.role === UserRole.REGIONALMANAGER
        ) {
            return false;
        }
        return true;
    }

    changeWarehouse(id: string) {
        localStorage.setItem('warehouseId', id);
        this.selectedWarehouseId = id;
        this.refreshPage();
    }

    async isSelectedWarehouseNational() {
        const warehouses = await DataStore.query(Warehouse);
        const selectedWarehouse = warehouses.find(
            (w) => w.id === this.selectedWarehouseId
        );
        if (selectedWarehouse.locationType === LocationType.NATIONAL) {
            return true;
        } else {
            return false;
        }
    }

    refreshPage() {
        const uri = this.router.url;
        this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate([uri]));
    }
}
